import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { add } from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class GoogleMapService {

  constructor(private http: HttpClient) { }

  /** -------------------------------------- */
  getAddress(lat: number, lan: number) {
    return this.http
      .get<any>(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lan}&key=${environment.firebase.apiKey}`
      )
      .pipe(
        map(geoData => {
          if (!geoData || !geoData.results || geoData.results === 0) {
            return null;
          }
          return geoData.results[0].formatted_address;
        })
      );
  }

  /** -------------------------------------- */
  getZipcode(lat: number, lan: number) {
    return this.http
      .get<any>(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lan}&result_type=postal_code&key=${environment.firebase.apiKey}`
      )
      .pipe(
        map(geoData => {
          if (!geoData || !geoData.results || geoData.results === 0) {
            return null;
          }
          return geoData.results[0].address_components[0].long_name;
        })
      );
  }

/** -------------------------------------- */
  getNearbyStores(lat: number, lng: number, nextPageToken = '') {
    let params: string;
    if (nextPageToken) {
      params = `key=${environment.firebase.apiKey}&pagetoken=${nextPageToken}`;
    } else {
      params = `location=${lat},${lng}&rankby=distance&type=store&key=${environment.firebase.apiKey}`;
    }

    return this.http
      .get<any>('https://cors-anywhere.herokuapp.com/https://maps.googleapis.com/maps/api/place/nearbysearch/json?' + params)
      .pipe(
        map(geoData => {
          return {
            nextPageToken: geoData.next_page_token,
            stores: geoData.results.filter(store =>
              store.types.includes('grocery_or_supermarket') ||
              store.types.includes('department_store') ||
              store.types.includes('pharmacy')
            )
          };
        })
      );
  }

/** -------------------------------------- */
  getPlaceId(retailer: string, address: string, name: string) {
    address = address.replace(/\s/g, '+');
    name = name.replace(/\s/g, '+');

    return this.http
      .get<any>(
        'https://cors-anywhere.herokuapp.com/https://maps.googleapis.com/maps/api/place/findplacefromtext/json?' +
        `input=${retailer}+${name}+${address}&inputtype=textquery&fields=place_id&key=${environment.firebase.apiKey}`
      );
  }

/** -------------------------------------- */
  getPlaceDetail(placeId: string) {
    return this.http
      .get<any>(
        'https://cors-anywhere.herokuapp.com/https://maps.googleapis.com/maps/api/place/details/json?' +
        `place_id=${placeId}&fields=opening_hours,formatted_phone_number&key=${environment.firebase.apiKey}`
      );
  }

/** -------------------------------------- */
  getCoordinates(address: string) {
    return this.http
      .get<any>(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${address.replace(/ /g, '+')}&key=${environment.firebase.apiKey}`);
  }
}
